import React, { useState, useEffect, useRef } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { db, auth } from '../../services/firebaseConnection';
import { collection, getDocs, doc, setDoc, query, getDoc, runTransaction, orderBy, FieldPath, onSnapshot } from 'firebase/firestore';
import LogoBarberia from '../../assets/LogoBarbearia.png';
import { useNavigate } from 'react-router-dom';
import { functions } from '../../services/firebaseConnection';
import { httpsCallable } from 'firebase/functions';
import { QRCodeCanvas } from 'qrcode.react';
import './homeCli.css';
export default function HomeCli() {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [profissionais, setProfissionais] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [selectedProfessional, setSelectedProfessional] = useState('');
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [idToken, setIdToken] = useState('');
  const [cpf, setCpf] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [qrCodeValue, setQrCodeValue] = useState('');
  const [timeLeft, setTimeLeft] = useState(300); // 300 segundos = 5 minutos
  const [businessHours, setBusinessHours] = useState({});
  useEffect(() => {
    // Horários de funcionamento em tempo real (assinatura, não leitura única):
    // - ignora respostas vindas só do cache: offline no carregamento devolvia
    //   lista vazia e a tela ficava sem horários a sessão inteira;
    // - o Firestore reconecta sozinho em rede instável de celular;
    // - uma assinatura ativa mantém o canal aberto e evita o "handshake frio"
    //   a cada escolha de data (o canal fechava após 60 s ocioso).
    const unsubscribe = onSnapshot(
      collection(db, "businessHours"),
      { includeMetadataChanges: true },
      (querySnapshot) => {
        if (querySnapshot.metadata.fromCache) return; // espera a resposta do servidor
        const hoursData = {};
        querySnapshot.forEach((doc) => {
          const data = doc.data(); // campos 'day', 'open', 'close' e (opcional) 'closed'
          hoursData[data.day] = { open: data.open, close: data.close, closed: data.closed };
        });
        businessHoursRef.current = hoursData;
        setBusinessHours(hoursData);
      },
      (error) => {
        console.error('Erro ao carregar horários de funcionamento:', error);
        alert('Não foi possível carregar os horários de funcionamento. Verifique sua conexão e recarregue a página.');
      }
    );
    return () => unsubscribe();
  }, []);
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async user => {
      if (user) {
        // Buscar informações adicionais do usuário na coleção 'users'
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          // Usuário encontrado na coleção 'users'
          setLoggedInUser({ name: userSnap.data().name, id: user.uid });
          // Aqui obtemos o token de ID do usuário logado
          user.getIdToken().then((token) => {
            setIdToken(token); // Armazenamos o token de ID no estado
          }).catch((error) => {
            // Trate os erros aqui
            console.error(error);
          });
        } else {
          // Documento não existe na coleção 'users'
          console.error("Usuário não encontrado na coleção 'users'");
        }
      } else {
        // Usuário não está logado
        setLoggedInUser(null);
        setIdToken(''); // Limpar o token de ID quando não houver usuário logado
      }
    });
    // Limpar subscription
    return () => unsubscribe();
  }, []);
  const handleLogout = async () => {
    try {
      await auth.signOut();
      // Depois que o signOut for bem sucedido, redirecione para a página Home
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async user => {
      if (user) {
        // Buscar informações adicionais do usuário na coleção 'users'
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          // Usuário encontrado na coleção 'users'
          setLoggedInUser({ name: userSnap.data().name, id: user.uid });
        } else {
          // Documento não existe na coleção 'users'
          console.error("Usuário não encontrado na coleção 'users'");
        }
      } else {
        // Usuário não está logado
        setLoggedInUser(null);
      }
    });
    // Limpar subscription
    return () => unsubscribe();
  }, []);
  // O 'price' pode vir como número ou string (ex.: "30" ou "30,00") do Firestore.
  // Converte com segurança para número; valor inválido vira 0.
  const toNumber = (value) => {
    if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
    const parsed = parseFloat(String(value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : 0;
  };
  const calculateTotal = () => {
    const totalServices = selectedServices.reduce((total, serviceName) => {
      const service = services.find(s => s.name === serviceName);
      return total + (service ? toNumber(service.price) : 0);
    }, 0);
    const totalProducts = selectedProducts.reduce((total, productName) => {
      const product = products.find(p => p.name === productName);
      return total + (product ? toNumber(product.price) : 0);
    }, 0);
    const total = totalServices + totalProducts;
    return total.toFixed(2); // Formata como string com duas casas decimais
  };
  // Busca só os documentos que têm agendamentos na data escolhida (muito mais leve
  // que baixar a coleção inteira). Se a consulta falhar, volta ao modo antigo.
  const fetchAppointmentDocsForDate = async (date) => {
    const appointmentsRef = collection(db, 'agendamentos');
    try {
      const snap = await getDocs(query(appointmentsRef, orderBy(new FieldPath(date))));
      return snap.docs;
    } catch (error) {
      console.error('Consulta por data falhou, usando busca completa:', error);
      const snap = await getDocs(appointmentsRef);
      return snap.docs;
    }
  };
  // Função para verificar se o horário já está reservado
  const isTimeSlotAvailable = async (date, time, professional) => {
    const appointmentDocsList = await fetchAppointmentDocsForDate(date);
    let isAvailable = true;
    appointmentDocsList.forEach((doc) => {
      const userAppointments = doc.data()[date] || [];
      userAppointments.forEach((appointment) => {
        if (appointment.hora === time && appointment.professional === professional) {
          isAvailable = false;
        }
      });
    });
    return isAvailable; // Retorna true se o horário estiver disponível
  };
  const [availableTimes, setAvailableTimes] = useState([]);
  // true enquanto uma busca de horários está em andamento (mostra "Carregando...")
  const [loadingTimes, setLoadingTimes] = useState(false);
  // Sequência das buscas: a resposta de uma busca antiga que chega DEPOIS de uma
  // mais nova é descartada. Sem isso, em rede lenta de celular, uma busca iniciada
  // antes de os horários de funcionamento carregarem terminava por último e
  // apagava a lista correta ("sem horários" mesmo havendo horários).
  const fetchSeqRef = useRef(0);
  // Espelho dos horários de funcionamento sempre atual (closures antigas leem daqui)
  const businessHoursRef = useRef({});
  // Horários de funcionamento já carregados? Antes disso não há o que calcular.
  const businessHoursLoaded = Object.keys(businessHours).length > 0;

  // Calcula os horários disponíveis da data. Retorna:
  //  'ok'      calculou e atualizou a lista
  //  'closed'  dia fechado (lista vazia de propósito)
  //  'waiting' horários de funcionamento ainda não chegaram (o efeito abaixo refaz)
  //  'stale'   descartada porque uma busca mais nova começou
  //  'error'   falha de rede
  // Repete uma leitura que falhou por instabilidade de rede (Wi-Fi↔4G, aba em
  // segundo plano, canal frio): 3 tentativas com espera progressiva. Desiste
  // antes se uma busca mais nova já começou.
  const withRetry = async (read, isStale) => {
    let lastError;
    for (let attempt = 1; attempt <= 3; attempt++) {
      try {
        return await read();
      } catch (error) {
        lastError = error;
        if (isStale() || attempt === 3) break;
        await new Promise((resolve) => setTimeout(resolve, 700 * attempt));
      }
    }
    throw lastError;
  };
  const fetchAppointmentsForDate = async (date, professional) => {
    // Lê os horários pela referência (versão mais recente) e decide ANTES de
    // invalidar buscas anteriores: uma chamada presa numa closure antiga não
    // pode cancelar a busca válida em andamento nem deixar "Carregando..." preso
    const currentHours = businessHoursRef.current;
    setLoadingTimes(true);
    if (Object.keys(currentHours).length === 0) {
      // Mantém "Carregando..." — a busca é refeita sozinha quando os horários chegarem
      return 'waiting';
    }
    const fetchSeq = ++fetchSeqRef.current;
    const isStale = () => fetchSeq !== fetchSeqRef.current;
    try {
      const dayOfWeek = new Date(date).getDay();

      // Primeiro, verifica se a data tem horários especiais
      const specialDaySnap = await withRetry(() => getDoc(doc(db, "specialDays", date)), isStale);
      if (isStale()) return 'stale';
      let hours;
      let reservedTimes = [];

      if (specialDaySnap.exists()) {
        const specialDayData = specialDaySnap.data();
        const professionalDetails = professional && specialDayData.professionals
          ? specialDayData.professionals[professional]
          : undefined;

        const mergedDetails = {
          status: professionalDetails?.status ?? specialDayData.status,
          open: professionalDetails?.open ?? specialDayData.open,
          close: professionalDetails?.close ?? specialDayData.close,
          times: professionalDetails?.times ?? specialDayData.times,
        };

        if (mergedDetails.status === "Fechado") {
          if (mergedDetails.open && mergedDetails.close) {
            hours = currentHours[dayOfWeek];
            for (let h = parseInt(mergedDetails.open); h <= parseInt(mergedDetails.close); h++) {
              reservedTimes.push(`${h.toString().padStart(2, '0')}:00`);
            }
          } else {
            setAvailableTimes([]);
            return 'closed';
          }
        } else if (mergedDetails.status === "Especial" && mergedDetails.open && mergedDetails.close) {
          hours = { open: mergedDetails.open, close: mergedDetails.close };
        } else if (mergedDetails.status === "Reservado" && Array.isArray(mergedDetails.times)) {
          hours = currentHours[dayOfWeek];
          reservedTimes = mergedDetails.times.map(time => time.close).filter(time => time);
          if (mergedDetails.close) {
            reservedTimes.push(mergedDetails.close);
          }
        } else {
          hours = currentHours[dayOfWeek];
        }
      } else {
        hours = currentHours[dayOfWeek];
      }

      if (!hours || hours.closed) {
        setAvailableTimes([]);
        return 'closed';
      }

      const appointmentDocsList = await withRetry(() => fetchAppointmentDocsForDate(date), isStale);
      if (isStale()) return 'stale';

      const bookedTimes = new Set();
      const shouldFilterByProfessional = Boolean(professional);
      appointmentDocsList.forEach((doc) => {
        const userAppointments = doc.data()[date] || [];
        userAppointments.forEach((appointment) => {
          if (!shouldFilterByProfessional) {
            return;
          }
          if (appointment.professional === professional) {
            bookedTimes.add(appointment.hora);
          }
        });
      });

      // Adiciona todos os horários reservados aos horários já marcados
      reservedTimes.forEach(time => bookedTimes.add(time));
      // Determina os horários disponíveis de acordo com o dia da semana
      const newAvailableTimes = [];
      for (let hour = parseInt(hours.open); hour <= parseInt(hours.close); hour++) {
        const formattedHour = `${hour < 10 ? '0' : ''}${hour}:00`;
        if (!bookedTimes.has(formattedHour)) {
          newAvailableTimes.push(formattedHour);
        }
      }
      setAvailableTimes(newAvailableTimes.filter(time => time !== "13:00"));
      return 'ok';
    } catch (error) {
      console.error('Erro ao carregar horários:', error);
      if (!isStale()) {
        setAvailableTimes([]);
        alert('Não foi possível carregar os horários. Verifique sua conexão e selecione a data novamente.');
      }
      return 'error';
    } finally {
      // Se uma busca mais nova está em andamento, ela é quem encerra o "Carregando..."
      if (!isStale()) setLoadingTimes(false);
    }
  };
  // O seletor de data do iOS dispara uma mudança a cada "tique" da roda;
  // espera 300 ms de silêncio antes de buscar (cada tique seria uma ida ao servidor)
  const dateChangeTimerRef = useRef(null);
  useEffect(() => () => clearTimeout(dateChangeTimerRef.current), []);
  const handleDateChange = (e) => {
    const newDate = e.target.value; // A data selecionada no formato 'yyyy-mm-dd'
    setSelectedDate(newDate);
    setSelectedTime('');
    // Limpar horários disponíveis antes de verificar a nova data
    setAvailableTimes([]);
    clearTimeout(dateChangeTimerRef.current);
    if (!newDate) {
      fetchSeqRef.current++; // descarta qualquer busca em andamento da data anterior
      setLoadingTimes(false);
      return;
    }
    setLoadingTimes(true);
    dateChangeTimerRef.current = setTimeout(async () => {
      const result = await fetchAppointmentsForDate(newDate, selectedProfessional);
      if (result === 'closed') {
        alert("Este dia está fechado para agendamentos.");
      }
    }, 300);
  };

  useEffect(() => {
    // Refaz a busca quando o profissional muda ou quando os horários de
    // funcionamento terminam de carregar (corrige a tela sem horários ao abrir)
    if (!selectedDate || !businessHoursLoaded) {
      return;
    }
    fetchAppointmentsForDate(selectedDate, selectedProfessional);
  }, [selectedProfessional, businessHoursLoaded]);


  const handleTimeChange = (e) => {
    setSelectedTime(e.target.value);
  };
  // Função para verificar se um CPF é válido
  function validateCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf === '') return false;
    // Elimina CPFs invalidos conhecidos
    if (cpf.length !== 11 || cpf === '00000000000' || cpf === '11111111111' || cpf === '22222222222' || cpf === '33333333333' || cpf === '44444444444' || cpf === '55555555555' || cpf === '66666666666' || cpf === '77777777777' || cpf === '88888888888' || cpf === '99999999999') {
      return false;
    }
    // Valida 1o digito
    let add = 0;
    for (let i = 0; i < 9; i++) {
      add += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let rev = 11 - (add % 11);
    if (rev === 10 || rev === 11) rev = 0;
    if (rev !== parseInt(cpf.charAt(9))) return false;
    // Valida 2o digito
    add = 0;
    for (let i = 0; i < 10; i++) {
      add += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rev = 11 - (add % 11);
    if (rev === 10 || rev === 11) rev = 0;
    if (rev !== parseInt(cpf.charAt(10))) return false;
    return true;
  }
  const handlePayment = async () => {
    setLoading(true);
    // Verificações iniciais
    const currentDate = new Date();
    const selectedDateTime = new Date(`${selectedDate}T${selectedTime}`);
    // Verifica se pelo menos um serviço foi selecionado ao tentar comprar um produto
    if (selectedProducts.length > 0 && selectedServices.length === 0) {
      alert("É necessário escolher pelo menos um serviço para comprar produtos.");
      setLoading(false);
      return;
    }
    if (selectedDateTime < currentDate) {
      alert("Não é possível agendar um horário no passado.");
      setLoading(false);
      return;
    }
    if (!selectedDate || !selectedTime || !selectedProfessional || !loggedInUser) {
      alert("Por favor, selecione data, hora, um profissional e esteja logado.");
      setLoading(false);
      return;
    }
    // Verifique se o horário está disponível
    const available = await isTimeSlotAvailable(selectedDate, selectedTime, selectedProfessional);
    if (!available) {
      alert("Este horário já está reservado. Por favor, escolha outro horário.");
      setLoading(false);
      return;
    }
    // Verifica se o CPF foi digitado corretamente e se é válido
    if (cpf.length !== 11 || !validateCPF(cpf)) {
      alert("Por favor, insira um CPF válido.");
      setLoading(false);
      return;
    }
    try {
      const createPayment = httpsCallable(functions, 'createPixPayment');
      const createPixCharge = httpsCallable(functions, 'createPixCharge');
      const checkPixPayment = httpsCallable(functions, 'checkPixPayment');
      // Chamada para criar o pagamento e obter o token
      const paymentResponse = await createPayment({});
      const token = paymentResponse.data.access_token; // Acessando o token
      setPaymentToken(token); // Armazena o token no estado
      // Chamada para criar a cobrança Pix com o token
      const chargeResponse = await createPixCharge({
        token, // Token de acesso
        dadosCobranca: {
          calendario: { expiracao: 60000 },
          devedor: { cpf: cpf, nome: loggedInUser.name },
          valor: { original: calculateTotal() },
          chave: "27856074000180",
          //39723453000181
          solicitacaoPagador: "Barbearia Corte's Curte"
        }
      });
      // Obtenha o txid da resposta
      const txid = chargeResponse.data.txid;
      setPaymentTxid(txid); // Armazena o txid no estado
      const location = chargeResponse.data.location; // Localização obtida da resposta
      // Gerando o QR Code EMV
      const payloadFormatIndicator = '000201';
      const pointOfInitiationMethod = '010212';
      const merchantAccountInformation = `26850014br.gov.bcb.pix2563${location}`; // Inclui location na string
      const merchantCategoryCode = '52040000';
      const transactionCurrency = '5303986';
      const transactionAmount = '54040.00';
      const country = '5802BR';
      const merchantName = '5910Jefers sou';
      const merchantCity = '6009SAO PAULO';
      const additionalDataFieldTemplate = '62070503***';
      const crcTable = [
        0x0000, 0x1021, 0x2042, 0x3063, 0x4084, 0x50A5, 0x60C6, 0x70E7,
        0x8108, 0x9129, 0xA14A, 0xB16B, 0xC18C, 0xD1AD, 0xE1CE, 0xF1EF,
        0x1231, 0x0210, 0x3273, 0x2252, 0x52B5, 0x4294, 0x72F7, 0x62D6,
        0x9339, 0x8318, 0xB37B, 0xA35A, 0xD3BD, 0xC39C, 0xF3FF, 0xE3DE,
        0x2462, 0x3443, 0x0420, 0x1401, 0x64E6, 0x74C7, 0x44A4, 0x5485,
        0xA56A, 0xB54B, 0x8528, 0x9509, 0xE5EE, 0xF5CF, 0xC5AC, 0xD58D,
        0x3653, 0x2672, 0x1611, 0x0630, 0x76D7, 0x66F6, 0x5695, 0x46B4,
        0xB75B, 0xA77A, 0x9719, 0x8738, 0xF7DF, 0xE7FE, 0xD79D, 0xC7BC,
        0x48C4, 0x58E5, 0x6886, 0x78A7, 0x0840, 0x1861, 0x2802, 0x3823,
        0xC9CC, 0xD9ED, 0xE98E, 0xF9AF, 0x8948, 0x9969, 0xA90A, 0xB92B,
        0x5AF5, 0x4AD4, 0x7AB7, 0x6A96, 0x1A71, 0x0A50, 0x3A33, 0x2A12,
        0xDBFD, 0xCBDC, 0xFBBF, 0xEB9E, 0x9B79, 0x8B58, 0xBB3B, 0xAB1A,
        0x6CA6, 0x7C87, 0x4CE4, 0x5CC5, 0x2C22, 0x3C03, 0x0C60, 0x1C41,
        0xEDAE, 0xFD8F, 0xCDEC, 0xDDCD, 0xAD2A, 0xBD0B, 0x8D68, 0x9D49,
        0x7E97, 0x6EB6, 0x5ED5, 0x4EF4, 0x3E13, 0x2E32, 0x1E51, 0x0E70,
        0xFF9F, 0xEFBE, 0xDFDD, 0xCFFC, 0xBF1B, 0xAF3A, 0x9F59, 0x8F78,
        0x9188, 0x81A9, 0xB1CA, 0xA1EB, 0xD10C, 0xC12D, 0xF14E, 0xE16F,
        0x1080, 0x00A1, 0x30C2, 0x20E3, 0x5004, 0x4025, 0x7046, 0x6067,
        0x83B9, 0x9398, 0xA3FB, 0xB3DA, 0xC33D, 0xD31C, 0xE37F, 0xF35E,
        0x02B1, 0x1290, 0x22F3, 0x32D2, 0x4235, 0x5214, 0x6277, 0x7256,
        0xB5EA, 0xA5CB, 0x95A8, 0x8589, 0xF56E, 0xE54F, 0xD52C, 0xC50D,
        0x34E2, 0x24C3, 0x14A0, 0x0481, 0x7466, 0x6447, 0x5424, 0x4405,
        0xA7DB, 0xB7FA, 0x8799, 0x97B8, 0xE75F, 0xF77E, 0xC71D, 0xD73C,
        0x26D3, 0x36F2, 0x0691, 0x16B0, 0x6657, 0x7676, 0x4615, 0x5634,
        0xD94C, 0xC96D, 0xF90E, 0xE92F, 0x99C8, 0x89E9, 0xB98A, 0xA9AB,
        0x5844, 0x4865, 0x7806, 0x6827, 0x18C0, 0x08E1, 0x3882, 0x28A3,
        0xCB7D, 0xDB5C, 0xEB3F, 0xFB1E, 0x8BF9, 0x9BD8, 0xABBB, 0xBB9A,
        0x4A75, 0x5A54, 0x6A37, 0x7A16, 0x0AF1, 0x1AD0, 0x2AB3, 0x3A92,
        0xFD2E, 0xED0F, 0xDD6C, 0xCD4D, 0xBDAA, 0xAD8B, 0x9DE8, 0x8DC9,
        0x7C26, 0x6C07, 0x5C64, 0x4C45, 0x3CA2, 0x2C83, 0x1CE0, 0x0CC1,
        0xEF1F, 0xFF3E, 0xCF5D, 0xDF7C, 0xAF9B, 0xBFBA, 0x8FD9, 0x9FF8,
        0x6E17, 0x7E36, 0x4E55, 0x5E74, 0x2E93, 0x3EB2, 0x0ED1, 0x1EF0,
      ];
      function crc16(data) {
        let crc = 0xFFFF; // Inicialização com 0xFFFF
        for (let i = 0; i < data.length; i++) {
          let byte = data.charCodeAt(i);
          let tableIndex = ((crc >> 8) ^ byte) & 0xFF;
          crc = crcTable[tableIndex] ^ (crc << 8);
        }
        return crc & 0xFFFF; // Garantir que o CRC é de 16 bits
      }
      // Converter a string EMV para um array de bytes
      const emvStringSemCRC = `${payloadFormatIndicator}${pointOfInitiationMethod}${merchantAccountInformation}${merchantCategoryCode}${transactionCurrency}${transactionAmount}${country}${merchantName}${merchantCity}${additionalDataFieldTemplate}6304`;
      // Calculando o CRC
      const crc = crc16(emvStringSemCRC).toString(16).toUpperCase().padStart(4, '0');
      const emvString = `${emvStringSemCRC}${crc}`; // Adiciona o CRC calculado ao final
      // Gerar a imagem do QR Code usando a string EMV
      setQrCodeValue(emvString);
      setIsModalOpen(true);
      const currentDate = new Date();
      const selectedDateTime = new Date(`${selectedDate}T${selectedTime}`);
      if (selectedDateTime < currentDate) {
        alert("Não é possível agendar um horário no passado.");
        return;
      }
      if (!selectedDate || !selectedTime || !selectedProfessional || !loggedInUser) {
        alert("Por favor, selecione data, hora, um profissional e esteja logado.");
        return;
      }
      // Verifique se o horário está disponível
      const available = await isTimeSlotAvailable(selectedDate, selectedTime, selectedProfessional);
      if (!available) {
        alert("Este horário já está reservado. Por favor, escolha outro horário.");
        return;
      }
      await bookAppointment('Pendente', txid, null, token);
      let attempts = 0;
      const maxAttempts = 30; // Número máximo de tentativas (5 minutos)
      const pollingInterval = setInterval(async () => {
        try {
          const checkPixPaymentResponse = await checkPixPayment({ token });
          const checkPixPaymentData = checkPixPaymentResponse.data;
          const txidMatch = checkPixPaymentData.pix.find(pix => pix.txid === txid);
          if (txidMatch) {
            clearInterval(pollingInterval);
            // Atualizar o agendamento para confirmado
            await bookAppointment('Confirmado', txid, txidMatch, token);
            alert('Pagamento confirmado! Lembre-se, você tem 10 minutos de tolerância para chegar na barbearia!!');
            navigate('/agendamentos');
          } else if (attempts >= maxAttempts) {
            clearInterval(pollingInterval);
            console.log("Timeout: Pagamento não confirmado após várias tentativas.");
          }
          attempts++;
        } catch (error) {
          console.error("Erro ao verificar o pagamento:", error);
        }
      }, 30000); // Verifica a cada 30 segundos
      setMessage('Pagamento realizado com sucesso!');
    } catch (error) {
      console.error("Erro ao criar pagamento Pix: ", error);
      setMessage('Erro ao realizar o pagamento.');
    } finally {
      setLoading(false);
    }
  };
  const [paymentToken, setPaymentToken] = useState(null);
  const [paymentTxid, setPaymentTxid] = useState(null);
  const verifyPixPayment = async (txid, token) => {
    try {
      const checkPixPayment = httpsCallable(functions, 'checkPixPayment');
      const checkPixPaymentResponse = await checkPixPayment({ token });
      const checkPixPaymentData = checkPixPaymentResponse.data;
      // Procura por um pagamento com o txid correspondente
      const txidMatch = checkPixPaymentData.pix.find(pix => pix.txid === txid);
      if (txidMatch) {
        await bookAppointment('Confirmado', txid, txidMatch, token);
        setMessage('Pagamento confirmado com sucesso!');
        alert('Pagamento confirmado! Lembre-se, você tem 10 minutos de tolerância para chegar na barbearia!!');
        navigate('/agendamentos');
      } else {
        alert('Pagamento não confirmado.');
        console.log("Pagamento não confirmado.");
        setMessage('Pagamento não confirmado.');
      }
    } catch (error) {
      alert('Pagamento não confirmado.');
      console.error("Erro ao verificar o pagamento: ", error);
      setMessage('Erro ao verificar o pagamento.');
    }
  }
  const bookAppointment = async (status, txid, txidMatch, token) => {
    const currentDate = new Date();
    const selectedDateTime = new Date(`${selectedDate}T${selectedTime}`);
    const totalToPay = calculateTotal();
    if (totalToPay <= 0) {
      alert("Selecione serviços ou produtos para continuar.");
      return;
    }
    // Verifica se pelo menos um serviço foi selecionado ao tentar comprar um produto
    if (selectedProducts.length > 0 && selectedServices.length === 0) {
      alert("É necessário escolher pelo menos um serviço para comprar produtos.");
      return;
    }
    if (selectedDateTime < currentDate) {
      alert("Não é possível agendar um horário no passado.");
      return;
    }
    if (!selectedDate || !selectedTime || !selectedProfessional || !loggedInUser) {
      alert("Por favor, selecione data, hora, um profissional e esteja logado.");
      return;
    }
    const appointmentData = {
      date: selectedDate,
      data: selectedDate,
      hora: selectedTime,
      professional: selectedProfessional,
      services: selectedServices,
      products: selectedProducts,
      userName: loggedInUser.name,
      userId: loggedInUser.id,
      txid: txid, // Salvar o txid do pagamento PIX
      pagamento: txidMatch,
      paymentStatus: status, // 'pending' ou 'confirmed'
      createdAt: new Date().toISOString(), // usado para não excluir pendências recém-criadas
    };
    const dateField = selectedDate; // Definindo dateField
    const userAppointmentsPath = `agendamentos/${loggedInUser.id}`;
    const appointmentRef = doc(db, userAppointmentsPath);
    try {
      // Verifica se o documento existe e cria se necessário
      const docSnapshot = await getDoc(appointmentRef);
      if (!docSnapshot.exists()) {
        await setDoc(appointmentRef, { [dateField]: [] });
      }
      // Executa a transação
      await runTransaction(db, async (transaction) => {
        const userDoc = await transaction.get(appointmentRef);
        if (!userDoc.exists()) {
          throw new Error("Documento não existe!");
        }
        let appointmentsByDate = userDoc.data()[dateField] || [];
        const existingIndex = appointmentsByDate.findIndex(appointment => appointment.txid === txid);
        if (existingIndex !== -1) {
          // Atualiza o agendamento existente
          appointmentsByDate[existingIndex].paymentStatus = status;
          appointmentsByDate[existingIndex].pagamento = txidMatch;
        } else {
          // Cria um novo agendamento
          appointmentsByDate.push(appointmentData);
        }
        let updatedData = {};
        updatedData[dateField] = appointmentsByDate;
        transaction.update(appointmentRef, updatedData);
      });
      // alert('Pagamento confirmado! Lembre-se, você tem 10 minutos de tolerância para chegar na barbearia!!');
      // navigate('/agendamentos');
    } catch (error) {
      console.error('Erro ao realizar agendamento:', error);
      alert(`Erro ao realizar agendamento. Detalhes: ${error.message || error}`);
    }
  };
  function handleServiceSelection(serviceName) {
    if (selectedServices.includes(serviceName)) {
      setSelectedServices(prev => prev.filter(name => name !== serviceName));
    } else {
      setSelectedServices(prev => [serviceName, ...prev]);
    }
  }
  function handleProductSelection(productName) {
    if (selectedProducts.includes(productName)) {
      setSelectedProducts(prev => prev.filter(name => name !== productName));
    } else {
      setSelectedProducts(prev => [productName, ...prev]);
    }
  }
  // Catálogo (serviços, profissionais, produtos) em tempo real, ignorando
  // respostas só de cache — mesma proteção dos horários de funcionamento
  useEffect(() => {
    const subscribeList = (collectionName, setter) => onSnapshot(
      collection(db, collectionName),
      { includeMetadataChanges: true },
      (snapshot) => {
        if (snapshot.metadata.fromCache) return;
        setter(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      },
      (error) => console.error(`Erro ao carregar ${collectionName}:`, error)
    );
    const unsubscribers = [
      subscribeList('services', setServices),
      subscribeList('profissionais', setProfissionais),
      subscribeList('products', setProducts),
    ];
    return () => unsubscribers.forEach((unsubscribe) => unsubscribe());
  }, []);
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleAgendaClick = () => {
    navigate('/agendamentos');
  };
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(qrCodeValue)
      .then(() => {
        alert('QR Code copiado para a área de transferência!');
      })
      .catch(err => {
        console.error('Erro ao copiar QR Code:', err);
        alert('Falha ao copiar QR Code.');
      });
  };
  useEffect(() => {
    // Sair cedo se o modal não estiver aberto ou se o tempo acabou
    if (!isModalOpen || timeLeft <= 0) return;
    // Definir um timeout para diminuir o tempo restante
    const timerId = setTimeout(() => {
      if (timeLeft - 1 <= 0) {
        // Recarregar a página quando o tempo acabar
        window.location.reload();
      } else {
        setTimeLeft(timeLeft - 1);
      }
    }, 1000);
    // Limpar o timeout se o componente for desmontado
    return () => clearTimeout(timerId);
  }, [isModalOpen, timeLeft]);
  return (
    <div className="container">
      <nav className="navbar">
        <img src={LogoBarberia} alt="Logo" className="logo" />
        <div className="navbar-center">
          <div className="navbar-links">
            <a href="#Servicos" className="nav-link">Serviços</a>
            <a href="#Profissionais" className="nav-link">Profissionais</a>
            <a href="#Produtos" className="nav-link">Produtos</a>
          </div>
        </div>
        <button className="agendamento-button" onClick={handleAgendaClick}>Meus agendamentos</button>
        <button className="logout-button" onClick={handleLogout}>Sair</button>
      </nav>
      <section id="Servicos" className="products-section">
        <div className="title-wrapper">
          <h2 className='title-buy'>Tipos de Serviços</h2>
        </div>
        <div className="products-carousel">
          {services.map(service => (
            <div className="product-card" key={service.name}>
              <h3>{service.name}</h3>
              <h4>R$ {service.price},00</h4>
              <button onClick={() => handleServiceSelection(service.name)}>
                {selectedServices.includes(service.name) ? 'Remover' : 'Selecionar'}
              </button>
            </div>
          ))}
        </div>
      </section>
      <section id="Profissionais" className="products-section">
        <div className="title-wrapper">
          <h2 className='title-buy'>Profissionais</h2>
        </div>
        <div className="products-carousel">
          {profissionais.map(profissional => (
            <div className="product-card" key={profissional.name}>
              <img className='imgSrc' src={profissional.imgSrc} alt={profissional.name} />
              <h3>{profissional.name}</h3>
            </div>
          ))}
        </div>
      </section>
      <section id="Produtos" className="products-section">
        <div className="title-wrapper">
          <h2 className='title-buy'>Produtos</h2>
        </div>
        <div className="products-carousel">
          {products.map(product => (
            <div className="product-card" key={product.name}>
              <h3>{product.name}</h3>
              <h4> R$ {product.price},00</h4>
              <button onClick={() => handleProductSelection(product.name)}>
                {selectedProducts.includes(product.name) ? 'Remover' : 'Selecionar'}
              </button>
            </div>
          ))}
        </div>
      </section>
      <div className="agendamento-section">
                <select
          value={selectedProfessional}
          onChange={(e) => setSelectedProfessional(e.target.value)}
        >
          <option value="">Selecione um Profissional</option>
          {profissionais.map((profissional) => (
            <option key={profissional.id} value={profissional.name}>
              {profissional.name}
            </option>
          ))}
        </select>
        <div className="input-group">
          <label htmlFor="dateInput">Data</label>
          <input
            id="dateInput"
            type="date"
            placeholder="dd/mm/aaaa"
            min={new Date().toISOString().split('T')[0]}
            value={selectedDate}
            onChange={handleDateChange}
          />
        </div>
        <div className="input-group">
          <label htmlFor="timeSelect">Horário</label>
          <select
            id="timeSelect"
            value={selectedTime}
            onChange={handleTimeChange}
            disabled={loadingTimes}
          >
            <option value="" disabled>
              {loadingTimes
                ? 'Carregando horários...'
                : (selectedDate && availableTimes.length === 0
                  ? 'Nenhum horário disponível'
                  : 'Selecione um horário')}
            </option>
            {availableTimes.map((hour) => (
              <option key={hour} value={hour}>{hour}</option>
            ))}
          </select>
        </div>
        <div className='total'>Total a Pagar: {calculateTotal()}</div>
        <input type="number" placeholder="CPF" value={cpf} maxLength={11} onChange={e => setCpf(e.target.value.replace(/\D/g, '').slice(0, 11))} />
        <button onClick={handlePayment} disabled={loading}>
          {loading ? 'Processando...' : 'Pagar e agendar'}
        </button>
      </div>
      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>QR Code do Pagamento</h2>
            <QRCodeCanvas value={qrCodeValue} size={256} level={"H"} includeMargin={true} />
            <h3>Codigo copia e cola ⬇️ </h3>
            <p>{qrCodeValue}</p>
            <h3>Tempo restante para pagamento: {Math.floor(timeLeft / 60)}:{String(timeLeft % 60).padStart(2, '0')}</h3>
            <button onClick={handleCopyToClipboard}>Copiar QR Code</button>
            <button onClick={() => verifyPixPayment(paymentTxid, paymentToken)}>Já fiz o pagamento</button>
          </div>
        </div>
      )}
    </div>
  );
}